import {mapVersion} from 'app/components/entities/maintenance/mapper/maintenance.mapper';

export const MaintenanceMapper = {mapVersion};
